<div class="vsa-page-container">
    <lib-viz-http-status
        [errorNumber]="errorNumber"
        [errorHeading]="errorHeading"
        [errorDescription]="errorDescription"
        [showButton]="false"
    ></lib-viz-http-status>
    <app-footer/>
</div>
